import { ReloadOutlined } from '@ant-design/icons'
import { Button } from 'antd'
import { FC } from 'react'
import { useLazyGetLastStampOrderByStampQuery } from '../../../../../store/api/stamp-orders-api'
import { useNavigate } from 'react-router-dom'
import { dynamicRoutes } from '../../../../../constants/routes'
import qs from 'qs'

interface ReorderProps {
    stampDocId: string
}

const Reorder: FC<ReorderProps> = ({ stampDocId }) => {
    const [get] = useLazyGetLastStampOrderByStampQuery()
    const navigate = useNavigate()

    const onClick = async () => {
        const result = await get(stampDocId)

        if ('data' in result) {
            const stampOrder = result.data?.data[0]
            if (stampOrder) {
                const query = qs.stringify({ copyBy: stampOrder.documentId })
                navigate(dynamicRoutes.purchasesStampOrdersNewByCopy(query))
            }
        }
    }

    return (
        <Button
            size={'small'}
            icon={<ReloadOutlined />}
            title={'Перезаказать штамп'}
            onClick={onClick}
        />
    )
}

export default Reorder
